<template>
  <v-card title="考勤汇总统计">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="24">
            <div style="text-align: left">
              <v-form-item>
                <vxe-input
                  size="mini"
                  v-model="kqyf"
                  placeholder="考勤月份"
                  type="month"
                  valueFormat="yyyyMM"
                ></vxe-input>
              </v-form-item>
              <v-form-item>
                <v-input placeholder="输入工号或姓名" v-model="cx"></v-input>
              </v-form-item>
              <v-form-item>
                <!-- <v-select placeholder="请选择客户" style="width: 150px;" :data="khbh_options" v-model="khbh"></v-select> -->
                <vxe-select v-model="khbh" size="mini" placeholder="请选择客户" :options="khbh_options" clearable @change="xz_khbh"></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-tree-select
                  @check="onCheck"
                  @clear="onClear"
                  style="padding-top: 2px; width: 200px"
                  :data="treeData2"
                  placeholder="请选择地区"
                  allow-clear
                  multiple
                ></v-tree-select>
              </v-form-item>
              <v-form-item>
                <vxe-select
                  v-model="fz"
                  size="mini"
                  placeholder="请选择组别"
                  :options="fz_options"
                  clearable
                ></vxe-select>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
              <v-form-item>
                <v-button type="warning" icon="export" @click="exportExcel()"
                  ><span>导出</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      border
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = {
  id: "",
};
export default {
  data() {
    return {
      options,
      tableData: [],
      khbh_options: [],
      treeData2: [],
      fz_options:[],
      dq: [],
      fz:"",
      sql:"",
      cx: "",
      khbh:"",
      kqyf: dateFormat("YYYYmm", new Date()),
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        checkboxConfig: {
          labelField: "id",
          highlight: true,
          range: true,
        },
        editConfig: {
          trigger: "", //click可以编辑表格
          mode: "row",
          showStatus: true,
        },
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
          {
            field: "gh",
            title: "工号",
            align: "center",
          },
          {
            field: "xm",
            title: "姓名",
            align: "center",
          },
          {
            field: "khbh",
            title: "客户编号",
            align: "center",
          },
          {
            field: "khmc",
            title: "客户名称",
            align: "center",
          },
          {
            field: "zw",
            title: "职位",
            align: "center",
          },
          {
            field: "ts",
            title: "出勤天数",
            headerAlign:"center",
            align: "right",
          },
          {
            title: "请假",
            align: "center",
            children: [
              { field: "nj", title: "年假（天）" ,headerAlign:"center",align: "right"},
              { field: "sj", title: "事假（小时）" ,headerAlign:"center",align: "right"},
              { field: "bj", title: "病假（小时）" ,headerAlign:"center",align: "right"},
              { field: "tx", title: "调休（小时）" ,headerAlign:"center",align: "right"},
              { field: "cj", title: "产假（天）" ,headerAlign:"center",align: "right"},
              { field: "pcj", title: "陪产假（天）" ,headerAlign:"center",align: "right"},
              { field: "hj", title: "婚假（天）" ,headerAlign:"center",align: "right"},
              { field: "sangj", title: "丧假（天）" ,headerAlign:"center",align: "right"},
              { field: "yej", title: "育儿假（天）" ,headerAlign:"center",align: "right"},
            ],
          },
          {
            title: "加班",
            align: "center",
            children: [
              { field: "gzrjb", title: "工作日加班" ,headerAlign:"center",align: "right"},
              { field: "xxrjb", title: "休息日加班" ,headerAlign:"center",align: "right"},
              { field: "jjrjb", title: "节假日加班" ,headerAlign:"center",align: "right"},
            ],
          },
        ],
      },
    };
  },
  created() {
    this.init_khbh();
    this.findList();
  },
  methods: {
    findList() {
      if(this.kqyf == ""){
        this.$message["error"]("请选择考勤月份！");
        return;
      }
      this.$axios
        .get(
          "api/system/kqhztj/get-kqhztj-list?cx=" +
            this.cx +
            "&kqyf=" +
            this.kqyf+
            "&khbh="+
            this.khbh+
            "&dq=" +
            this.dq+
            "&fz="+this.fz
        )
        .then((res) => {
          this.tableData = res.data.data;
          this.sql = res.data.sql;
        });
    },
    init_khbh: function () {
      this.$axios.get("api/system/rywh/get-rywh-khbh").then((res) => {
        let self = this;
        self.khbh_options = res.data.map((item) => {
          return { value: item.khbh, label: item.khjc };
        });
      });
    },
    xz_khbh: function () {
      this.init_dq();
    },
    init_dq: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-dq?khbh=" + this.khbh)
        .then((res) => {
          let self = this;
          if (res.data.code == 200) {
            let self = this;
            self.treeData2 = res.data.data;
          } else {
            this.$message["error"](res.data.message);
          }
        });
    },
    init_fz: function () {
      this.$axios
        .get("api/system/xjcx/get-xjcx-fz?khbh=" + this.khbh + "&khdq=" + this.dq)
        .then((res) => {
          let self = this;
          self.fz_options = res.data.data.map((item) => {debugger;
            return { value: item.fzmc, label: item.fzmc };
          });
        });
    },
    exportExcel() {
      let a = document.createElement("a");
      a.href =
        "api/system/kqhztj/考勤统计?cx=" +
            this.cx +
            "&kqyf=" +
            this.kqyf+
            "&khbh="+
            this.khbh+
            "&dq=" +
            this.dq+
            "&fz="+this.fz
      a.click();
    },
    onCheck(data) {
      this.dq = [];
      for (var i = 0; i < data.length; i++) {
        this.dq.push(data[i].id);
      }
      // this.dq = [];
      // for (var i = 0; i < data.length; i++) {
      //   if (data[i].children) {
      //     for (var j = 0; j < data[i].children.length; j++) {
      //       this.dq.push(data[i].children[j].id);
      //     }
      //   }
      // }
      this.init_fz();
      console.log(this.dq);
    },
    onClear(data) {
      this.dq = [];
      this.fz = "";
      console.log("clear", this.dq);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
  },
};
function dateFormat(fmt, date) {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/bbtj/kqhztj.vue